import { createContext } from 'react';

export const programContext = createContext({});

export default programContext;
